import { Injectable } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DialogService } from "@teammood/shared/ui/dialog";
import { TmSaveCommentDialogComponent } from "./add-comment/save-comment-dialog/save-comment-dialog.component";
import { Mood } from "@teammood/timeline";

@Injectable(
    { providedIn: 'root' }
)
export class AddFeedbackDialogService {

    constructor(
        private dialogService: DialogService
    ) {}

    async openSaveCommentDialog(mood: Mood): Promise<MatDialogRef<TmSaveCommentDialogComponent>> {
        return this.dialogService.open(TmSaveCommentDialogComponent, {
            width: '100%',
            maxWidth: '480px',
            enterAnimationDuration: 0,
            exitAnimationDuration: 0,
            data: {
                mood: mood
            }
        });
    }
    
}